import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import BookDetail from "./pages/BookDetail";

function App() {
  return (
    <Router>
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/books" element={<BookDetail />} />
        <Route path="/books/:bookId" element={<BookDetail />} />
      </Routes>
    </Router>
  );
}
export default App;
